import React from 'react';

const Contact = () => (
  <section className="page">
    <h1>Contact</h1>
    <p>
      Got questions, ideas, or just wanna chat about Hestia Ledger? I’m Blueprint Byte, the guy behind 
      this, and I’m here to help. Reach out anytime—I don’t bite.
    </p>
    <p>
      Email me at <a href="mailto:bell@hestialedger.com">bell@hestialedger.com</a>. I’ll get back to you 
      as soon as I can, usually when I’m not starving or coding.
    </p>
    <a href="http://app.hestialedger.com" className="cta-button">Try Now!</a>
  </section>
);

export default Contact;